/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiV1BorCompaniesCompanyIdPscReportPdfGet$Params {

/**
 * Company ID
 */
  companyId: number;
}

export function apiV1BorCompaniesCompanyIdPscReportPdfGet(http: HttpClient, rootUrl: string, params: ApiV1BorCompaniesCompanyIdPscReportPdfGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, apiV1BorCompaniesCompanyIdPscReportPdfGet.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/pdf', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

apiV1BorCompaniesCompanyIdPscReportPdfGet.PATH = '/api/v1/bor/companies/{companyId}/psc/report.pdf';
